/**
* 数据面板
*/

<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>数据面板</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="日期：">
        <el-date-picker
          v-model="formInline.date"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>

      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="queryByDate()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        align="center"
        prop="matisetname"
        label="物料套装名称">
      </el-table-column>
      <el-table-column
        align="center"
        prop="batchNumber"
        label="批次名称"
        width="180">
      </el-table-column>

      <el-table-column
        align="center"
        prop="ordernumber"
        label="订单（数量）="
        width="180">
      </el-table-column>
      <el-table-column
        align="center"
        prop="ordernofinish"
        label="[ 待合成订单（个）+">
      </el-table-column>

      <el-table-column
        align="center"
        prop="orderfinish"
        label="已合成订单（个）]="
        width="180">
      </el-table-column>

      <el-table-column
        align="center"
        prop="ordernodeliverynumber"
        label="[ 待发货订单（个）+">
      </el-table-column>

      <el-table-column
        align="center"
        prop="orderdeliverynumber"
        label="已发货订单（个）]">
      </el-table-column>



      <el-table-column
        align="center"
        prop="filenumber"
        label="合成PDF文件">
      </el-table-column>

            <el-table-column
              align="center"
              prop="errorder"
              label="当前合成失败（数量）"
              width="180">
              <div slot-scope="scope"   >
                {{scope.row.errorder}}
              </div>
            </el-table-column>
      <el-table-column
        align="center"
        prop="bumanumber"
        label="补码数量（个）">
      </el-table-column>



    </el-table>

    <el-row>
      <el-col :span="12" class="grid-content">
          <div width="100%" align="center">
            <span  style="font-size:26px">今日合成进度</span>
          </div>
        <div  width="100%"  align="center">
          <el-progress type="dashboard" :percentage="percentagehc" :color="colors" :width="300" :height="300"></el-progress>
        </div>


      </el-col>
      <el-col :span="12"  class="grid-content">
        <div width="100%" align="center">
          <span style="font-size:26px">今日发货进度</span>
        </div>
        <div  width="100%"  align="center">
          <el-progress type="dashboard" :percentage="percentagefh" :color="colors" :width="300" :height="300"></el-progress>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import {
    buma,
    query,
    queryByDate
  } from '../../api/ordersMG'
  import Pagination from '../../components/Pagination'
 // import {marketPromoteList} from "../../api/marketPromoteMG";
  export default {
    name: "orders",
    data() {
      return {
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        formInline: {
          date:[]
        },

        listData: [] , //用户数据
        errDatas:[] ,// 错误提醒
        date:'',
        tableData:[],
        percentagehc: 0,
        percentagefh: 0,
        colors: [
          {color: '#f56c6c', percentage: 20},
          {color: '#e6a23c', percentage: 40},
          {color: '#6f7ad3', percentage: 60},
          {color: '#1989fa', percentage: 80},
          {color: '#5cb87a', percentage: 100}
        ]

      }
    },

    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {

      getdata(parameter) {
        this.loading = true
        /***
         * 调用接口，注释上面模拟数据 取消下面注释
         */
        query(parameter)
          .then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.tableData = res.data
              this.percentagehc=parseFloat(res.data[res.data.length-1].orderfinish*100/res.data[res.data.length-1].ordernumber).toFixed(2)
              this.percentagefh=parseFloat(res.data[res.data.length-1].orderdeliverynumber*100/res.data[res.data.length-1].ordernumber).toFixed(2)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('获取信息失败，请稍后再试！')
          })
      },
      queryByDate()
      {
        this.loading = true
        /***
         * 调用接口，注释上面模拟数据 取消下面注释
         */
        query(this.formInline)
          .then(res => {
            this.loading = false
            if (res.code != 0) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.tableData = res.data

            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('获取信息失败，请稍后再试！')
          })
      }


    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 500px;
    top:50%;
    left:50%;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
</style>




// WEBPACK FOOTER //
// src/views/orders/Count.vue